import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import PostCard from "@/components/blog/PostCard";
import { usePublishedPosts } from "@/hooks/usePosts";
import { Helmet } from "react-helmet-async";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const Stories = () => {
  const { data: posts, isLoading } = usePublishedPosts();

  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Impact Stories | Referral Connection Network</title>
        <meta
          name="description"
          content="Read stories from RCN members making a difference in Washington, Missouri through fundraising, service, and collaboration."
        />
        <link rel="canonical" href={`${window.location.origin}/impact/stories`} />
      </Helmet>
      <Navigation />

      <section className="pt-32 pb-12 bg-gradient-to-br from-primary/10 via-background to-accent/10">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Impact Stories</h1>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Discover how our members are making a difference through fundraising, community service, and collaboration.
          </p>
        </div>
      </section>

      <section className="flex-1 py-12 bg-background">
        <div className="container mx-auto px-4">
          {isLoading ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {[0, 1, 2].map((i) => (
                <Skeleton key={i} className="h-96 w-full rounded-lg" />
              ))}
            </div>
          ) : posts && posts.length > 0 ? (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {posts.map((post) => (
                <PostCard key={post.id} post={post} />
              ))}
            </div>
          ) : (
            <Card className="p-12 text-center max-w-2xl mx-auto">
              <CardContent>
                <h3 className="text-xl font-semibold mb-2">More Stories Coming Soon</h3>
                <p className="text-muted-foreground">
                  Check back to see how our members continue to make an impact in our community.
                </p>
              </CardContent>
            </Card>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Stories;
